import React from 'react';
import classnames from 'classnames';
import Text from '../Text/Text';

import './Card.scss';

export interface CardProps {
    /**
     * Ref checkbox
     */
    ref?: any;
    /**
     * Tag
     */
    tag?: any;
    /**
     * Background card
     */
    background?: '' | 'primary' | 'secondary' | 'tertiary' | 'white' | 'dark' | 'gray';
    /**
     * Disabled
     */
    disabled?: boolean;
    /**
     * Elevation shadow
     */
    elevation?: number | string;
    /**
     *  Rounded border in card
     */
    rounded?: boolean;
    /**
     * Bordered in card
     */
    bordered?: boolean;
    /**
     * Gradient border
     */
    borderColor?: '' | 'primary' | 'secondary' | 'tertiary' | 'dark' | 'gray' | 'gradient';
    /**
     * Apply mobile styles
     */
    mobile?: boolean;
    /**
     * Apply hovered styles
     */
    hovered?: boolean;
    /**
     * Persist default style
     */
    persist?: boolean;
    /**
     * Loading
     */
    loading?: boolean;
    /**
     * Badge color
     */
    badgeColor?:
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'accent'
        | 'success'
        | 'warning'
        | 'error'
        | 'info'
        | 'none'
        | 'white'
        | 'dark';
    /**
     * Badge text
     */
    badgeText?: string;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style Card
     */
    style?: any;
    /**
     * Slot component
     */
    children?: React.ReactNode;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

const Card: React.FC<CardProps> = React.forwardRef(
    (
        {
            tag: Tag = 'div',
            background = 'white',
            disabled = false,
            loading = false,
            elevation = 1,
            rounded = true,
            bordered = false,
            borderColor = '',
            hovered = false,
            mobile = false,
            persist = false,
            badgeColor = 'secondary',
            badgeText = '',
            className,
            style = {},
            children,
            ...otherProps
        },
        ref
    ) => {
        const classNames = classnames([
            'card',
            `elevation-${elevation}`,
            background,
            ...(borderColor ? [`border-${borderColor}`] : []),
            {
                disabled,
                rounded,
                bordered,
                mobile,
                hovered,
            },
            className,
        ]);

        return (
            <Tag ref={ref} className={classNames} style={style} {...otherProps}>
                {badgeText ? (
                    <div className={`card__badge ${badgeColor}`}>
                        <Text weight="bold" size="small" className="card__badge--text">
                            {badgeText}
                        </Text>
                    </div>
                ) : null}
                {(loading || disabled) && <div className="card__overlay"></div>}
                <div className="card__wrapper">{children}</div>
            </Tag>
        );
    }
);

export default Card;
